export default __webpack_public_path__ + "static/media/ai-sales-tranning.ace96fea.png";